import React from 'react';
import useStyle from './externalLink.style';
import { classNames } from 'helpers/style/classNames';
import { Icon } from '../../Icons';
import { FlatIcon } from '../../Icons/FlatIcon';

export type ExtenalLinkVariant = 'link' | 'ressource' | 'helpLanding';

export interface ExternalLinkProps {
  link: string;
  isOpenNewTab?: boolean;
  textInside?: string;
  variant: ExtenalLinkVariant;
  icon?: Icon;
  color?: string;
  onClick?: () => void;
}

export const ExternalLink = ({
  link = '',
  isOpenNewTab = true,
  textInside,
  variant,
  icon,
  color,
  onClick
}: ExternalLinkProps) => {
  const classes = useStyle({ color });
  return (
    <div onClick={onClick}>
      <a
        href={link}
        target={isOpenNewTab ? '_blank' : null}
        className={classNames(
          [classes.root],
          [
            {
              condition: variant === 'link',
              classe: classes.link
            },
            {
              condition: variant === 'ressource',
              classe: classes.ressource
            },
            {
              condition: variant === 'helpLanding',
              classe: classes.helpLanding
            }
          ]
        )}
        rel="noreferrer"
      >
        {textInside}
        {icon && <FlatIcon icon={icon} color={'#FFF'} />}
      </a>
    </div>
  );
};
